import { useState } from 'react';
import { CTAModal } from './CTAModal';

export function FutureSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const futures = [
    {
      icon: 'ri-line-chart-line',
      title: '点数UP',
      description: '定期テストで20〜30点アップも可能。苦手科目も克服できます。',
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '提出物管理',
      description: '提出物の進捗を管理。期限に遅れることがなくなります。',
      color: 'bg-green-500'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '学習習慣',
      description: '毎日の勉強が習慣化。自分から机に向かうようになります。',
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-parent-line',
      title: '親の安心',
      description: '定期的な報告で進捗を共有。お子様の成長を実感できます。',
      color: 'bg-purple-500'
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            この塾なら<br className="md:hidden" />こう変わる
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市の個別指導で、お子様の未来が変わります
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {futures.map((future, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1"
            >
              <div className={`w-14 h-14 flex items-center justify-center ${future.color} rounded-xl mb-4 shadow-md`}>
                <i className={`${future.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {future.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {future.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-center text-white shadow-xl">
          <h3 className="text-2xl md:text-3xl font-black mb-4">
            成績アップで内申点も向上
          </h3>
          <p className="text-sm md:text-base mb-6 leading-relaxed">
            定期テスト対策と提出物管理で、<br />
            内申点アップを実現。<br />
            高校受験に向けて、<br />
            今から準備を始めましょう。
          </p>
          <button 
            onClick={() => setIsModalOpen(true)}
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            無料体験で変化を実感する
          </button>
        </div>
      </div>

      <CTAModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        type="trial"
      />
    </section>
  );
}